import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    status: false,
    id: null,
    jwt: null,
    email: null,
    name: null,
    lastName: null,
  },
  reducers: {
    login: (state, action) => {
      state.jwt = action.payload;
      state.status = true;
    },
    logout: (state) => {
      state.status = false;
      state.jwt = null;
      state.id = null;
      state.email = null;
      state.name = null;
      state.lastName = null;
      localStorage.removeItem("x-token");
    },
    changeJWT: (state, action) => {
      state.jwt = action.payload.jwt;
      localStorage.removeItem("x-token");
      localStorage.setItem("x-token", state.jwt);
    },
    setInformationUser: (state, { payload }) => {
      state.email = payload.data.email;
      state.name = payload.data.name;
      state.lastName = payload.data.lastName;
      state.id = payload.data.id;
    },
  },
});

export const { login, logout, changeJWT, setInformationUser } =
  authSlice.actions;
